import React from 'react'
import WidgetWrapper from '../WidgetWrapper'

const Widget = props => {
  const { widget } = props
  return (
    <div>
      <iframe
        src={widget.data?.src}
        title="Embed"
        width={'100%'}
        height={widget.size?.height || '100%'}
        frameborder="0"
      />
    </div>
  )
}

const Wrapper = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Widget widget={widget} />
    </WidgetWrapper>
  )
}

export default Wrapper
